import { SITE_NAME, SITE_URL } from './constant';

export function setMetaTag(name: string, content: string, attribute: 'name' | 'property' = 'name') {
  let meta = document.querySelector<HTMLMetaElement>(`meta[${attribute}="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, name);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

export function setCanonical(href: string) {
  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
}

export function upsertJsonLd(id: string, data: Record<string, unknown>) {
  document.getElementById(id)?.remove();
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export function removeJsonLd(id: string) {
  document.getElementById(id)?.remove();
}

export function absoluteUrl(path = '/') {
  if (!path || path === '/') return SITE_URL;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

export function applyPageSeo({
  title,
  description,
  path,
  keywords,
  schemaId,
  schema,
}: {
  title: string;
  description: string;
  path: string;
  keywords?: string;
  schemaId?: string;
  schema?: Record<string, unknown> | Record<string, unknown>[];
}) {
  const canonical = absoluteUrl(path);
  document.title = title;
  setMetaTag('description', description);
  if (keywords) setMetaTag('keywords', keywords);
  setMetaTag('og:title', title, 'property');
  setMetaTag('og:description', description, 'property');
  setMetaTag('og:url', canonical, 'property');
  setMetaTag('og:type', 'website', 'property');
  setMetaTag('og:site_name', SITE_NAME, 'property');
  setMetaTag('og:image', `${SITE_URL}/og-image.png`, 'property');
  setCanonical(canonical);

  if (schemaId && schema) {
    upsertJsonLd(schemaId, Array.isArray(schema)
      ? { '@context': 'https://schema.org', '@graph': schema }
      : schema);
  }

  return () => {
    if (schemaId) removeJsonLd(schemaId);
  };
}

export function organizationSchema() {
  return {
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/logo512.png`,
  };
}
